import axios from "axios";
import AxiosClient from "../../services/axios.services";

class HolidaysServices {
  getHolidays = params =>
    AxiosClient.get("/api/app/head_clima_dias_no_habiles/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getHoliday = id =>
    AxiosClient.get(`/api/app/head_clima_dias_no_habiles/${id}`, {
      headers: { "Content-Type": "application/json" },
      
    });
  saveHoliday = data =>
    AxiosClient.post("/api/app/head_clima_dias_no_habiles/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editHoliday = (id, data) =>
    AxiosClient.put(
      `/api/app/head_clima_dias_no_habiles/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteHoliday = id =>
    AxiosClient.delete(`/api/app/head_clima_dias_no_habiles/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new HolidaysServices();